import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PoweredbyLogoComponent } from "./poweredby-logo.component";

@NgModule({
    declarations: [PoweredbyLogoComponent],
    imports: [CommonModule],
    exports: [PoweredbyLogoComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PoweredbyLogoModule {}
